<zf-loading-indicator *ngIf="isLoading()"></zf-loading-indicator>

<div *ngIf="!isLoading()" class="all-orgs-container">
    <h3 *ngIf="withTitle()" class="title">Make a Selection to Proceed</h3>
    <div *ngIf="withSearch()" class="search-container">
        <input type="text" placeholder="search me" />
    </div>
    <div class="content-container action-option-tree" [ngClass]="{'large': isLarge(), 'no-search': !withSearch()}">
        <div *ngFor="let o of orgNodes()" class="input-group">
            <div *ngFor="let r of o.nodes; let i = index" class="org-container">
                <div *ngIf="r.show" class="node" [hover-class]="r.isSelectable ? 'node-select' : null"
                    (click)="selectNode(r)"
                    [ngClass]="{'level-0': r.level === 0,'level-1': r.level === 1, 'level-2': r.level === 2, 'level-3': r.level === 3, 'level-4': r.level === 4 }">
                    <div class="node-content"
                        [ngClass]="{'has-arrow': ((r.type === 0 || r.type === 1) && r.hasMembers), 'no-arrow': (r.type === 2 || !r.hasMembers), 'collapse-view': r.selected }">
                        <span *ngIf="((r.type === 0 || r.type === 1) && r.hasMembers)" class="arrow-container"
                            [ngClass]="{'selected': r.selected}"
                            (click)="collapse(r.nodeId, i, r.selected); r.selected = !r.selected"><i
                                class="icon fontello-icon icon-arrowdown"></i></span>
                        <div class="ou-content-container">
                            <i class="icon fontello-icon "
                                [ngClass]="{'icon-rootfolder': r.type === 0, 'icon-folder': r.type === 1, 'icon-doc': r.type === 2}"></i>
                            <div class="ou-content">
                                <div class="ou-name">{{r.name}} <span
                                        *ngIf="(r.type === 0 || r.type === 1) && !r.hasMembers" class="no-acct">No
                                        Account
                                        Associated</span>
                                </div>
                                <div class="ou-desc">{{r.description}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
